import { type FC, type ReactNode } from "react";

import { Loader, Paper, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import clsx from "clsx";

import { actions as actionsClass, body, panel, searchInput, searchRow } from "./SearchPanel.module.css";

interface SearchPanelProps {
    searchPlaceholder?: string;
    searchValue?: string;
    onSearchChange?: (value: string) => void;
    actions?: ReactNode;
    isLoading?: boolean;
    children: ReactNode;
    className?: string;
}

export const SearchPanel: FC<SearchPanelProps> = ({
    searchPlaceholder,
    searchValue,
    onSearchChange,
    actions,
    isLoading,
    children,
    className,
}) => {
    return (
        <Paper radius="md" shadow="xs" className={clsx(panel, className)}>
            <div className={searchRow}>
                <TextInput
                    className={searchInput}
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(e) => onSearchChange?.(e.currentTarget.value)}
                    variant="unstyled"
                    leftSection={<IconSearch size={16} />}
                />
                {isLoading && <Loader size="xs" />}
                {actions && <div className={actionsClass}>{actions}</div>}
            </div>
            <div className={body}>{children}</div>
        </Paper>
    );
};
